import React from 'react'
import PropTypes from 'prop-types'
import InputWithState from './InputWithState'
import Dropdown from './Dropdown'
import CheckboxGroup from './CheckboxGroup'
import RadioButtonGroup from './RadioButtonGroup'
import SideBySideInputFields from './SideBySideInputFields'
import LeftSideContentView from './LeftSideContentView'
import RightSideContentView from './RightSideContentView'

import {
    ContentfulSideBySideInputFieldComponent,
    ContentfulDropdownFieldComponent,
    ContentfulTextInputFieldComponent,
    ContentfulRadioCheckBoxFieldComponent,
    ContentfulStaticInformationFieldComponent,
    ContentfulLeftSideContentViewComponent,
    ContentfulRightSideContentViewComponent,
} from '../constants/GeneralConstants'
import StaticInformationField from './StaticInformationField'

class GenericInputField extends React.Component {
    render() {

        const {
            data,
            typename,
            values,
            setFieldValue,
            touched,
            errors,
            errorMessages,
            theme,
            setFieldTouched,
            siteMetadata,
        } = this.props

        return (
            <>
                {typename === ContentfulSideBySideInputFieldComponent &&
                    <SideBySideInputFields
                        data={data}
                        values={values}
                        touched={touched}
                        errors={errors}
                        errorMessages={errorMessages}
                        setFieldValue={setFieldValue}
                        setFieldTouched={setFieldTouched}
                        theme={theme}
                        siteMetadata={siteMetadata}
                        {...this.props}
                    />
                }
                {typename === ContentfulRightSideContentViewComponent &&
                    <RightSideContentView {...this.props} />
                }
                {typename === ContentfulLeftSideContentViewComponent &&
                    <LeftSideContentView {...this.props} />
                }
                {typename === ContentfulTextInputFieldComponent &&
                    <InputWithState
                        data={data}
                        values={values}
                        touched={touched}
                        errors={errors}
                        errorMessages={errorMessages}
                        setFieldValue={setFieldValue}
                        setFieldTouched={setFieldTouched}
                        theme={theme}
                        siteMetadata={siteMetadata}
                        {...this.props}
                    />
                }
                {typename === ContentfulRadioCheckBoxFieldComponent && data.checkboxOrRadiobutton &&
                    <CheckboxGroup
                        data={data}
                        touched={touched}
                        errors={errors}
                        errorMessages={errorMessages}
                        setFieldTouched={setFieldTouched}
                        theme={theme}
                        {...this.props}
                    />
                }
                {typename === ContentfulRadioCheckBoxFieldComponent && !data.checkboxOrRadiobutton &&
                    <RadioButtonGroup
                        data={data}
                        touched={touched}
                        errors={errors}
                        errorMessages={errorMessages}
                        setFieldTouched={setFieldTouched}
                        theme={theme}
                        {...this.props}
                    />
                }
                {typename === ContentfulDropdownFieldComponent &&
                    <Dropdown
                        data={data}
                        values={values}
                        touched={touched}
                        errors={errors}
                        errorMessages={errorMessages}
                        setFieldValue={setFieldValue}
                        setFieldTouched={setFieldTouched}
                        theme={theme}
                        {...this.props}
                    />
                }
                {typename === ContentfulStaticInformationFieldComponent &&
                    <StaticInformationField
                        data={data}
                        theme={theme}
                        typename={typename}
                        {...this.props}
                    />
                }
            </>
        )
    }
}

GenericInputField.propTypes = {
    data: PropTypes.object,
    values: PropTypes.object,
    typename: PropTypes.string,
    setFieldValue: PropTypes.func,
    touched: PropTypes.object,
    errors: PropTypes.object,
    errorMessages: PropTypes.object,
    theme: PropTypes.object,
    setFieldTouched: PropTypes.func,
    siteMetadata: PropTypes.object
}

export default GenericInputField